import React from 'react'
import './InputField.scss'
import { CFormInput, CFormLabel, CFormText, CImage } from '@coreui/react-pro'
import PropTypes from 'prop-types'

const InputField = ({
  compressed,
  disabled,
  errormessage,
  id,
  invalid,
  label,
  onChange,
  placeholder,
  type,
  value,
  icon,
  onKeyDown,
  onFocus,
}) => {
  return (
    <>
      <div className="label-error-div-patient">
        <span className="label-container">
          {label && (
            <CFormLabel htmlFor={id} className={`input-label ${compressed && 'label-compressed'}`}>
              {label}
            </CFormLabel>
          )}
          {icon && <CImage className="label-icon" src={icon} />}
        </span>
      </div>

      <CFormInput
        onChange={onChange}
        id={id}
        disabled={disabled}
        className={`input-field ${invalid && 'invalid-input-field'} ${
          compressed && 'input-field-compressed'
        }`}
        type={type}
        value={value}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
      />

      <span
        className={`label-container error-container ${invalid && errormessage ? 'active' : ''}`}
      >
        <CFormText
          className={`error-message ${invalid && errormessage ? 'error-message-compressed' : ''}`}
          component={'div'}
        >
          {errormessage ? errormessage : ''}
        </CFormText>
      </span>
    </>
  )
}

InputField.propTypes = {
  compressed: PropTypes.bool,
  disabled: PropTypes.bool,
  errormessage: PropTypes.string,
  id: PropTypes.string,
  invalid: PropTypes.any,
  label: PropTypes.string || PropTypes.node,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  icon: PropTypes.any,
}

export default InputField
